import { useMutation } from "@tanstack/react-query";
import { memInfoApi } from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import { useBookInfContext } from "components/context/bookInfContext";
import BookStep3 from "components/view/book/step3";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { alertControl, emailRegex, phoneRegex } from "util/commAction";

export default function Bookstep3Page() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { bkStep, userInf, setUserInf } = useBookInfContext();
  const { isLogin } = useAuthContext();

  const userMutation = useMutation({
    mutationFn: memInfoApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const { emlId, memFstnm, memSurnm, mobNo, mobCntyCd } = data;

          setUserInf({
            cstFstnm: memFstnm,
            cstSurnm: memSurnm,
            emlId_1: emlId?.split("@")[0],
            emlId_2: emlId?.split("@")[1],
            emlId_3: "",
            cstEml: emlId,
            cstMblNo: mobNo,
            cstMblCntyCd: mobCntyCd,
            reqCn: "",
          });
          localStorage.setItem(
            "bkUserInf",
            JSON.stringify({
              cstFstnm: memFstnm,
              cstSurnm: memSurnm,
              emlId_1: emlId?.split("@")[0],
              emlId_2: emlId?.split("@")[1],
              emlId_3: "",
              cstEml: emlId,
              cstMblNo: mobNo,
              cstMblCntyCd: mobCntyCd,
              reqCn: "",
            })
          );
        }
        if (code === -1) {
          alertControl({
            isOpen: true,
            inner: message,
          });
        }
      }
    },
  });

  // 입력한 정보로 간편 회원가입
  const handleJoin = () => {
    const { cstEml, emlId_1, emlId_2, emlId_3, reqCn, ...res } = userInf;

    const params = {
      ...res,
      emlId: emlId_1 + "@" + (emlId_2 || emlId_3),
    };

    //이메일, 휴대폰 번호 정규식 체크
    if (!emailRegex.test(params.emlId)) {
      alertControl({
        isOpen: true,
        inner: t("alr_reg_mail"),
      });
      return;
    }

    if (!phoneRegex.test(params.cstMblNo)) {
      alertControl({
        isOpen: true,
        inner: t("alr_reg_pwd"),
      });
      return;
    }

    navigate("/join/term", {
      state: params,
    });
  };

  useEffect(() => {
    if (isLogin && bkStep === 3 && !userInf.emlId_1 && !userInf.emlId_2) {
      userMutation.mutate();
    }
  }, [isLogin, bkStep]);

  return <BookStep3 handleJoin={handleJoin} />;
}
